export const state = () => ({
  isLogout: false,
})

export const mutations = {
  setLogout(state, payload) {
    state.isLogout = payload ?? false;
  }
}